<template>
  <div class="page">
    <div class="pdf-box">
      <div>
        <div class="con-box">
          <MainTitle title="体能发育分析" tag="综合能力均分" />
          <div class="clearfix mt30">
            <BasePanel
              v-if="pieData.title"
              padding="20px"
              class="chart-item"
              :title="'综合能力'"
              title-color="#fff"
              head-bg="#FB834D"
              head-border-color="#FB834D"
            >
              <AvgScore
                v-if="pieData.others"
                label="均分"
                class="fl"
                :score="pieData.others[0]"
                color="#FB834D"
              />
              <Radar class="mt60" :data-list="pieData.details" />
              <div class="b-text" v-html="pieData.remark" />
            </BasePanel>
            <BasePanel
              v-for="(item, index) in barDataArray"
              :key="index"
              :title="item.title"
              padding="20px"
              class="chart-item"
              :button-text="item.code === 101 ? '查看子能区' : ''"
              @button-click="openClild(item.code)"
            >
              <AvgScore
                v-if="item.others"
                label="均分"
                class="fl"
                :score="item.others[0]"
              />
              <BarDifference class="mt80" :data-list="item.details" />
            </BasePanel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  synthEZAvgScore,
  getClassList
} from '@/api/teachingProtection/assessment'
import BasePanel from './BasePanel.vue'
import AvgScore from '../../_components/AvgScore.vue'
import Radar from '../../_components/charts/Radar.vue'
import BarDifference from '../../_components/charts/BarDifference.vue'
import MainTitle from './MainTitle.vue'

export default {
  components: {
    BasePanel,
    AvgScore,
    BarDifference,
    Radar,
    MainTitle
  },
  props: {
    data: {},
    searchParams: {}
  },
  data() {
    return {
      pieData: {},
      barDataArray: [],
      colorList: [],
      classroomName: '',
      sexName: '',
      ageName: ''
    }
  },
  created() {
    if (!this.searchParams) return
    let params = this.searchParams
    const classroomNames = []
    const sexNames = []
    const ageNames = []
    getClassList({
      periodType: params.periodType,
      year: params.year,
      semesterType: params.semesterType
    }).then((res) => {
      res.data.array.map((v) => {
        v.classrooms.map((q) => {
          if (params.classroomIds.indexOf(q.id) !== -1) {
            classroomNames.push(q.name)
          }
        })
      })
      this.classroomName = classroomNames.join('、')
    })
    this.$enums.gender.map((v) => {
      if (params.sexes.indexOf(v.code) !== -1) {
        sexNames.push(v.description)
      }
    })
    this.sexName = sexNames.join('、')
    this.$enums.groupAnalysisAgeType.map((v) => {
      if (params.ageRangeTypes.indexOf(v.code) !== -1) {
        ageNames.push(v.description)
      }
    })
    this.ageName = ageNames.join('、')
    synthEZAvgScore(this.searchParams).then((res) => {
      this.pieData = res.data.synthEZAvgScore
      this.barDataArray = res.data.barChart || []
    })
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.pdf-box {
  width: 1200px;
  background: #ffffff;
  // transform: scale(0.9);
  // transform-origin: 0 0 0;
  .con-box {
    padding: 30px;
  }
}
.search-term {
  min-width: 100px;
}
.search-con {
  background: #f0f4f7;
  border-radius: 2px;
  padding: 5px 10px;
  max-width: 600px;
  margin-left: 20px;
  line-height: 20px;
}
.type-box {
  font-size: 12px;
  .name {
    font-weight: 500;
    font-size: 22px;
    color: #333333;
    line-height: 30px;
    text-align: left;
    font-style: normal;
  }
  .val {
    color: #ff6c14;
  }
}
.chart-item {
  float: left;
  width: 360px;
  height: 320px;
  margin-right: 20px;
  margin-bottom: 20px;
}
.tips {
  height: 51px;
  line-height: 51px;
  margin-right: 20px;

  .item {
    float: left;
    margin-right: 20px;
    position: relative;
    padding-left: 20px;
    i {
      position: absolute;
      content: "";
      left: 0px;
      top: 17px;
      height: 15px;
      width: 15px;
    }
  }
}
</style>
